export default __webpack_public_path__ + "static/media/showData.b838ba15.png";